import { useState } from "react";
import API from "../utils/API";
import "./editProfileModal.css";

const TYPES = ["Problem", "Suggestion", "Question", "General Comment", "Other"];
const MAX_CHARS = 1000;

export default function FeedbackModal() {
    const [subject, setSubject] = useState("");
    const [feedbackType, setFeedbackType] = useState("");
    const [feedbackText, setFeedbackText] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const isValid = subject.trim() && feedbackType && feedbackText.trim();

    const handleSubmit = async () => {
        setError("");
        setLoading(true);
        try {
            await API.submitFeedback({
                subject: subject.trim(),
                feedback_type: feedbackType,
                feedback_text: feedbackText.trim(),
                page_url: window.location.pathname,
            });
            setSubmitted(true);
        } catch {
            setError("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setSubject("");
        setFeedbackType("");
        setFeedbackText("");
        setSubmitted(false);
        setError("");
    };

    return (
        <>
        <div className="modal fade edit-bio-modal" id="feedbackModal" tabIndex="-1" aria-hidden="true" data-bs-backdrop="static">
            <div className="modal-dialog">
                <div className="modal-content edit-profile-modal-content position-absolute top-50 start-50 translate-middle-x">
                    <div className="modal-header edit-bio-modal-header">
                        <h5 className="modal-title modal-title display-6">
                            <i className="bi bi-chat-square-text me-2" />Send Feedback
                        </h5>
                    </div>

                    <div className="modal-body px-4">
                        {submitted ? (
                            <div className="text-center py-3">
                                <i className="bi bi-check-circle-fill text-success fs-1 mb-3 d-block" />
                                <p className="fw-semibold mb-1">Thanks for your feedback!</p>
                                <p className="text-muted small">We read every submission and use it to improve the platform.</p>
                            </div>
                        ) : (
                            <div className="edit-profile-body">
                                <div className="row mt-2 mb-2">
                                    <div className="input-group input-group-sm">
                                        <input
                                            className="form-control"
                                            placeholder="Subject *"
                                            value={subject}
                                            onChange={e => setSubject(e.target.value)}
                                            maxLength={255}
                                        />
                                    </div>
                                </div>

                                <div className="row mb-2">
                                    <div className="input-group input-group-sm">
                                        <select
                                            className="form-select"
                                            value={feedbackType}
                                            onChange={e => setFeedbackType(e.target.value)}
                                        >
                                            <option value="">Type of feedback *</option>
                                            {TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                                        </select>
                                    </div>
                                </div>

                                <div className="row mb-1">
                                    <div className="input-group input-group-sm">
                                        <textarea
                                            className="form-control"
                                            rows={5}
                                            placeholder="Describe your feedback in detail *"
                                            value={feedbackText}
                                            onChange={e => setFeedbackText(e.target.value.slice(0, MAX_CHARS))}
                                            style={{ fontSize: '0.88rem', resize: 'vertical' }}
                                        />
                                    </div>
                                    <div className="text-end mt-1" style={{ fontSize: '0.72rem', color: feedbackText.length >= MAX_CHARS ? '#c0392b' : '#8a9aa2' }}>
                                        {feedbackText.length} / {MAX_CHARS}
                                    </div>
                                </div>

                                {error && <p className="text-danger small mt-1 mb-0">{error}</p>}
                            </div>
                        )}
                    </div>

                    <div className="modal-footer pt-0">
                        {submitted ? (
                            <button type="button" className="btn modal-save" data-bs-dismiss="modal" onClick={handleClose}>
                                Close
                            </button>
                        ) : (
                            <>
                                <button type="button" className="btn modal-close" data-bs-dismiss="modal" onClick={handleClose}>
                                    Cancel
                                </button>
                                <div className={isValid ? "" : "disabled-button"}>
                                    <button
                                        type="button"
                                        className="btn modal-save"
                                        disabled={!isValid || loading}
                                        onClick={handleSubmit}
                                    >
                                        {loading ? "Sending…" : "Submit Feedback"}
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}
